import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { InputAdornment, withStyles } from 'material-ui';
import AddCircle from 'material-ui-icons/AddCircle';
import SearchIcon from 'material-ui-icons/Search';
import * as PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { Field, Form, reduxForm, submit } from 'redux-form';
import renderSelectField from './RenderSelectField';
import renderTextField from './RenderTextFiled';

const styles = theme => ({
    lookupEditCell: {
        paddingTop: theme.spacing.unit * 0.875,
        paddingRight: theme.spacing.unit,
        paddingLeft: theme.spacing.unit,
    },
    dialog: {
        width: 'calc(100% - 16px)',
    },
    inputRoot: {
        width: '100%',
    },
    addIcon: {
        color: 'black'
    },
    headerToolbar: {
        width: '100%',
        margin: '2% 0 3% 0',
    },
    textField: {
        width: '100%'
    },
    formControl: {
        minWidth: '100%',
    },
    formContainer: {
        paddingRight: '20px'
    },
    pageHeading: {
        fontSize: '20px',
        padding: '0 2em',
    }
});


class TableFilters extends PureComponent {
    submitForm = () => {
        this.props.dispatch(submit('TableFilters'));
    };
    
    render() {
        const {
            addLink,
            classes,
            changeFilters,
            filterByOptions,
            handleSubmit,
            searchByOptions,
            title,
            productFilterOptions,
            showCloseEnd
        } = this.props;
    
        return (
            <Form
                onSubmit={handleSubmit(changeFilters)}
                className={classes.headerToolbar}
            >
                <Grid container alignContent="center" spacing={0}>
                    <Grid
                        container
                        item
                        justify='flex-start'
                        alignContent='flex-end'
                        xs={productFilterOptions && productFilterOptions.length !== 0 ? 3 : filterByOptions ? 4 : 6}
                        className={classes.pageHeading}
                    >
                        {title}
                    </Grid>
                    <Grid container item justify='flex-end' xs={2} className={classes.formContainer}>
                        <Field
                            name="searchBy"
                            component={renderSelectField}
                            label="Search By"
                            className={classes.textField}
                            divClassName={classes.formControl}
                            onChange={() => {
                                setTimeout(() => this.submitForm());
                            }}
                        >
                            {
                                searchByOptions.map(column => (
                                    <MenuItem value={column.name} key={column.name}>{column.label}</MenuItem>
                                ))
                            }
                        </Field>
                    </Grid>
                    <Grid container item justify='flex-end' xs={2} className={classes.formContainer}>
                        <Field
                            name="searchData"
                            component={renderTextField}
                            label="Search Data"
                            className={classes.textField}
                            divClassName={classes.formControl}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            onChange={() => {
                                setTimeout(() => this.submitForm());
                            }}
                        />
                    </Grid>
                    {
                        filterByOptions &&
                        <Grid container item justify='flex-end' xs={2} className={classes.formContainer}>
                            <Field
                                name="filterBy"
                                component={renderSelectField}
                                label="Filter Selection"
                                className={classes.textField}
                                divClassName={classes.formControl}
                                onChange={() => {
                                    setTimeout(() => this.submitForm());
                                }}
                            >
                                {
                                    filterByOptions.map(column => (
                                        <MenuItem value={column.name} key={column.name}>{column.label}</MenuItem>
                                    ))
                                }
                            </Field>
                        </Grid>
                    }
                    {
                        productFilterOptions && productFilterOptions.length !== 0 &&
                        <Grid container item justify='flex-end' xs={2} className={classes.formContainer}>
                            <Field
                                name="filterByProduct"
                                component={renderSelectField}
                                label="Filter By Product"
                                className={classes.textField}
                                divClassName={classes.formControl}
                                onChange={() => {
                                    setTimeout(() => this.submitForm());
                                }}
                            >
                                {
                                    productFilterOptions.map(column => (
                                        <MenuItem value={column.name} key={column.name}>{column.label}</MenuItem>
                                    ))
                                }
                            </Field>
                        </Grid>
                    }
                    <Grid container item justify='flex-end' alignContent='flex-end' xs={showCloseEnd || (productFilterOptions && productFilterOptions.length === 0) ? 2 : 1} className={classes.pageHeading}>
                        <Tooltip title="Add New" placement="right">
                            <Link
                                to={addLink}
                                href={addLink}
                                className={classes.addIcon}
                            >
                                <AddCircle />
                            </Link>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Form>
        );
    }
}

TableFilters.propTypes = {
    addLink: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    changeFilters: PropTypes.func,
    handleSubmit: PropTypes.func,
    filterByOptions: PropTypes.array,
    initialValues: PropTypes.object,
    searchByOptions: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    productFilterOptions: PropTypes.array
};

export default withStyles(styles, { name: 'TableFilters' })(reduxForm({ form: 'TableFilters', enableReinitialize: true })(TableFilters));


// WEBPACK FOOTER //
// ./src/helpers/TableFilters.js